import { Modal } from 'antd';
import * as React from 'react';
import { Small } from '@frontend/shadcn/components/typography/small';
import { TooltipTrigger } from '@radix-ui/react-tooltip';
import { Button } from '@frontend/shadcn/components/ui/button';
import { Tooltip, TooltipContent } from '@frontend/shadcn/components/ui/tooltip';

// Open modal to create offer
/* eslint-disable react/jsx-closing-tag-location */
interface IProps {
    isConfirmOfferCreationModalOpen: boolean;
    setIsConfirmOfferCreationModalOpen: (isModalOpen: boolean) => void;
    onFinish?: (isBoost?: boolean) => void;
    requiredFields: React.ReactNode;
    isSaving?: boolean
}
export const ConfirmOfferCreation = ({ isConfirmOfferCreationModalOpen, setIsConfirmOfferCreationModalOpen, onFinish, requiredFields, isSaving = false }: IProps) => {
    return <>
      <Modal
        open={isConfirmOfferCreationModalOpen}
        onCancel={() => setIsConfirmOfferCreationModalOpen(false)}
        title="Create your offer"
        footer={[
          <Button key="cancel" variant="secondary" onClick={() => setIsConfirmOfferCreationModalOpen(false)}>Cancel</Button>,
          <Tooltip key="create-offer">
            <TooltipTrigger asChild>
              <div className="inline-block">
                <Button variant="primary" type="submit" disabled={!!requiredFields || isSaving} onClick={() => onFinish()}>Create Offer & Continue</Button>
              </div>
            </TooltipTrigger>
            {requiredFields && (
            <TooltipContent>
              <span>{requiredFields}</span>
            </TooltipContent>
         )}
          </Tooltip>
        ]}
      >
        <div>
          <div className="flex flex-col gap-2">
            <Small>
              Click on save and continue to start creating your boosts for the very first time.
              You won't have to repeat this process. Once offer is created, you would be able to create boosts
            </Small>
          </div>
        </div>
      </Modal>
    </>;
};
